<div class="gridCalendarActions">
  @if (showButtonScrollBackward) {
    <button (click)="scrollBackward($event)" class="button_highlighted grey" hisImage="ARROW_UP_FAT" [title]="'cs.sys.hisng.gridcalendar.button.title.scrollBackward' | hisUi">
      {{'cs.sys.hisng.gridcalendar.button.text.scrollBackward' | hisUi}}
    </button>
  }
  @if (showButtonAddPreviousMonth) {
    <button (click)="addPreviousMonth($event)" class="button_highlighted grey" hisImage="PLUS_CIRC" [title]="'cs.sys.hisng.gridcalendar.button.title.addPreviousMonth' | hisUi">
      {{'cs.sys.hisng.gridcalendar.button.text.addPreviousMonth' | hisUi}}
    </button>
  }

  @if (showButtonRemoveFirstMonth) {
    <button (click)="removeFirstMonth()" class="button_highlighted grey" hisImage="MINUS_CIRC" [title]="'cs.sys.hisng.gridcalendar.button.title.removeFirstMonth' | hisUi">
      {{'cs.sys.hisng.gridcalendar.button.text.removeFirstMonth' | hisUi}}
    </button>
  }

  <button (click)="resetSelectedDays()" class="button_highlighted orange" hisImage="ARROW_ROTATE_BACK" [title]="'cs.sys.hisng.gridcalendar.button.title.resetInterval' | hisUi" [disabled]="!startDate && !endDate">
    {{'cs.sys.hisng.gridcalendar.button.text.resetInterval' | hisUi}}
  </button>

  @if (showYearPicker) {
    <his-plam [showLabelTop]="true" label="{{'cs.sys.hisng.gridcalendar.yearpicker.label' | hisUi}}" style="display:inline-block;">
        <p-calendar #content
                    #yearpicker
                    [(ngModel)]="selectedYear"
                    (ngModelChange)="loadYear($event)"
                    [readonlyInput]="false"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    view="year"
                    dateFormat="yy"
                    placeholder="{{'cs.sys.hisng.gridcalendar.yearpicker.placeholder' | hisUi}}"
                    title="{{'cs.sys.hisng.gridcalendar.yearpicker.title.pickYear' | hisUi}}"
                    styleClass="calendarWidth40 gridCalendarYearPicker">
        </p-calendar>
    </his-plam>
  }

  @if (showLegend) {
    <his-display-grid-calendar-legend
      [gridCalendarLegendDataProvider]="gridCalendarLegendDataProvider"
      [firstMonth]="firstMonth"
      [lastMonth]="lastMonth" />
  }
</div>

<p-table [value]="months"
  hisFrozencol
  class="tableStickyHeader calendarGridTable">

  <ng-template pTemplate="header">
    <tr>
      <th></th>
      @for (d of [].constructor(31); track $index; let i = $index) {
        <th class="dayTitleRow">{{ i+1 }}</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-month>
    <tr grid-calendar-month [month]="month" (dateSelected)="selectDate($event)"></tr>
  </ng-template>

</p-table>

@if (showButtonScrollForward) {
  <button (click)="scrollForward($event)" class="button_highlighted grey" hisImage="ARROW_DOWN_FAT" [title]="'cs.sys.hisng.gridcalendar.button.title.scrollForward' | hisUi">
    {{'cs.sys.hisng.gridcalendar.button.text.scrollForward' | hisUi}}
  </button>
}

@if (showButtonAddFollowingMonth) {
  <button (click)="addFollowingMonth($event)" class="button_highlighted grey" hisImage="PLUS_CIRC" [title]="'cs.sys.hisng.gridcalendar.button.title.addFollowingMonth' | hisUi">
    {{'cs.sys.hisng.gridcalendar.button.text.addFollowingMonth' | hisUi}}
  </button>
}

@if (showButtonRemoveLastMonth) {
  <button (click)="removeLastMonth()" class="button_highlighted grey" hisImage="MINUS_CIRC" [title]="'cs.sys.hisng.gridcalendar.button.title.removeLastMonth' | hisUi">
    {{'cs.sys.hisng.gridcalendar.button.text.removeLastMonth' | hisUi}}
  </button>
}

  <button (click)="resetSelectedDays()" class="button_highlighted orange" hisImage="ARROW_ROTATE_BACK" [title]="'cs.sys.hisng.gridcalendar.button.title.resetInterval' | hisUi" [disabled]="!startDate && !endDate">
    {{'cs.sys.hisng.gridcalendar.button.text.resetInterval' | hisUi}}
  </button>
